import {
    combineReducers
} from "@reduxjs/toolkit";
import {
    persistReducer,
} from "redux-persist";
import storage from "../helpers/persistStorage";
// import reducers from slices
import cartReducers from "./cartSlice";
import customerReducers from "./userSlice";
import storeReducers from "./storeSlice"
import globalReducers from "./globalSlice"
import collectionsReducers from "./collectionsSlice"
// create root reducers by combining everything
const rootReducer = combineReducers({
    global: persistReducer(
        {
            key: "global",
            version: 1,
            storage,
        },
        globalReducers
    ),
    cart: persistReducer(
        {
            key: "cart",
            version: 1,
            storage,
            blackList: [], // add keys which should not be cached: if using this then remove whiteList
            whiteList: [], // add keys which has to be tracked: if using this then remove blackList
        },
        cartReducers
    ),
    customer: persistReducer(
        {
            key: "customer",
            version: 1,
            storage,
        },
        customerReducers
    ),
    store: persistReducer(
        {
            key: "store",
            version: 1,
            storage,
        },
        storeReducers
    ),
    collections: persistReducer(
        {
            key: "collections",
            version: 1,
            storage,
        },
        collectionsReducers
    ),
});

export default rootReducer;